import { DateRange } from './date';

export class Merchants {
    id: number;
    code: number;
    name: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}

export class MerchantSearch {
    createdDate: DateRange = DateRange.empty();
    todayDate: DateRange = DateRange.today();
    id = '';
    code = '';
    name = '';
    companyName = '';
    field: 'name' | 'code' = 'name';
    value: '';
    mId = '';
    status = 'All';
    category = 'All';
    appCode = '';
    merchantType = '';
    isRemittanceMerchant = '';
 }

